$(function () {
    // prevent close and "clear" logic
    $('.form-filters .dropdown-menu').on('click', function (ev) {
        const $this = $(this);
        const $target = $(ev.target);
        if ($target.is('.btn-clear')) {
            $this.find('input[type=text]').val(null).change();
            $this.find('input[type=checkbox]').prop('checked', false);
            ev.preventDefault();
            ev.stopPropagation();
        } else if (!$target.is('.btnFilter')) {
            ev.stopPropagation();
        }
    });

    // single select checkbox logic
    $('.form-filters [data-single-checkbox]').on('click', function (ev) {
        const $this = $(this);
        const $target = $(ev.target);
        const isChecked = $target.prop('checked');
        if (isChecked) {
            $this.find('input[type=checkbox]').prop('checked', false).length;
            $target.prop('checked', true);
        }
    });

    // filter checkbox list logic
    $('.form-filters .form-group-search .form-group-search--filter input').on('keyup change', function () {
        console.log('here');
        const $this = $(this);
        if (!$this.data('is-setup')) {
            $this.data('is-setup', true);
            const targets = [];
            $this.closest('.form-group-search').find('.form-group-search--scroll .form-check').each(function () {
                const $el = $(this);
                targets.push({
                    el: $el,
                    show: function () {
                        this.el.removeClass('d-none');
                    },
                    hide: function () {
                        this.el.addClass('d-none');
                    },
                    text: $el.find('label').text().toLowerCase()
                });
            });
            $this.data('targets', targets);
        }
        const words = ($this.val() || '').split(' ').filter(w => w.trim() !== '').map(w => w.toLowerCase());
        const filterTargets = $this.data('targets');
        filterTargets.forEach(i => i.show());
        if (words.length) {
            const filtered = filterTargets.filter(i => words.filter(w => i.text.indexOf(w) >= 0).length !== words.length);
            filtered.forEach(i => i.hide());
        }
    });
});